import { TextFilterBase, ItemFilterBase } from '@common/filter/types';
import { itemModesSingleValueRequired } from '@common/filter/modes';
import { getFilterValidator } from '@common/filter/getFilterValidator';

export const quotationFilterOptions: { [key: string]: TextFilterBase | ItemFilterBase } = {
  QuotationFilter: {
    type: 'text',
  },

  DocumentFilter: {
    type: 'item',
  },

  DocumentGroupFilter: {
    type: 'item',
  },

  CodeFilter: {
    type: 'item',
  },

  CodeGroupFilter: {
    type: 'item',
  },

  CommentFilter: {
    type: 'text',
  },

  CreatorFilter: {
    type: 'item',
    allowedModes: itemModesSingleValueRequired,
  },
};

export const quotationFilterValidator = getFilterValidator(quotationFilterOptions);
